import { render, staticRenderFns } from "./diskspace.vue?vue&type=template&id=d11b3682&"
import script from "./diskspace.vue?vue&type=script&lang=js&"
export * from "./diskspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports